<template>
  <app-modal
    ref="modal"
    v-bind="$attrs"
    class="modal-container"
    content-class="modal-medium"
    title="確認"
  >
    <template v-slot:body="{ cancel, ok }">
      <!-- BODY -->
      <v-card-text class="pa-0">
        <div class="modal-body">
          <v-container>
            <v-row class="mb-3">
              <span
                v-if="confirmData.approvalState === 'COMPLETE'"
                class="font-weight-bold"
              >
                こちらのエクストラネット接続を切断します。よろしいですか？
              </span>
              <span
                v-else-if="confirmData.approvalState === 'APPLIED'"
                class="font-weight-bold"
                >こちらのエクストラネット接続申請を取り下げます。よろしいですか？
              </span>
            </v-row>
            <connection-info-table :connectionInfo="confirmData" />
          </v-container>
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <!-- FOOTER -->
      <v-card-actions>
        <v-list-item class="w-100 pa-1">
          <template v-slot:append>
            <v-btn @click="ok" variant="flat" color="primary">はい</v-btn>
            <v-btn @click="cancel" variant="outlined" color="primary"
              >いいえ</v-btn
            >
          </template>
        </v-list-item>
      </v-card-actions>
    </template>
  </app-modal>
</template>

<script lang="ts">
import type { PropType } from "vue";
import { defineComponent } from "vue";
import ConnectionInfoTable from "@/components/extranet/ConnectionInfoTable.vue";
import type { ExtranetInfo } from "@/apis/ExtranetApi";

export default defineComponent({
  name: "ExtranetDisconnectConfirm",
  components: { ConnectionInfoTable },
  props: {
    confirmData: {
      type: Object as PropType<ExtranetInfo>,
      required: true,
    },
  },
});
</script>
